var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.4,18.1c52.7-19.2,96.7-18.8,132,1.1c34.2,19.4,61.9,58.2,83,116.4c7.8,21.5,13.5,44,16.9,67.3 c3.4,23.3,4,43.4,1.7,60.3c-7.7,58.9-41.9,99.3-102.5,121.4c-44.8,16.3-85,15.2-120.5-3.4c-42.7-22.2-75.7-65.4-99.1-129.7 C26.2,191.7,22.8,142,37.7,102.4C51.9,65,84.8,36.9,136.4,18.1z M164,93.2c-25.1,9.1-41.3,24.7-48.6,46.6c-7.7,23.7-5,53.8,8.2,90.1 c12.8,35.1,29.3,60.5,49.6,76.4c20.6,16.2,44.1,19.4,70.5,9.8c27.2-9.9,43.1-28.2,47.9-55.1c4.8-27.2,0.9-58.2-11.7-92.9 C254.9,99.2,216.3,74.2,164,93.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.c1b324b4.svg";
export { ForwardRef as ReactComponent };